import { useLocation } from "wouter";
import { Text, Paper, Container, Loader, Center } from "@mantine/core";
import { useStore } from "../store";
// import mixpanel from "mixpanel-browser";
import { loginWithToken } from "../api";
import { useEffect, useRef } from "react";
import { notifications } from "@mantine/notifications";

export default function LoginLinkHandler({ params }) {
  const [, setLocation] = useLocation();
  // const authToken = useStore((state) => state.authToken);
  const setAuthToken = useStore((state) => state.setAuthToken);
  const initialized = useRef(false);

  // if (authToken) {
  //   return (
  //     <Container size="sm" mt="xl">
  //       <Paper radius="md" p="xl" withBorder {...props}>
  //         <Text size="lg" fw={500}>
  //           You are already logged in
  //         </Text>
  //       </Paper>
  //     </Container>
  //   );
  // }

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loginWithToken(params.token)
        .then((data) => {
          console.debug("data is", data);
          notifications.show({ title: "Logged in", color: "green" });
          setAuthToken(data.access_token);
          setLocation("/");
        })
        .catch((err) => {
          notifications.show({
            title: "Error",
            message: err.message,
            color: "red",
          });
        });
    }
  }, [params.token]);

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder>
        <Center>
          <Loader size="xl" />
          <Text>Logging you in...</Text>
        </Center>
      </Paper>
    </Container>
  );
}
